<!-- <p-table #pt [value]="users" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" [pageLinks]="3"
[lazy]="true" (onLazyLoad)="loadLazy($event)" [totalRecords]="recordTotal" [responsive]="true" sortMode="multiple"
[multiSortMeta]="multiSortMeta" dataKey="userId" [loading]="loading" [scrollable]="true" scrollHeight="500px"
[style]="{'width':'100%'}"> -->
<div class="container-fluid">
  <form *ngIf="formReady" [formGroup]="userAddForm">
    <mat-accordion>
      <mat-expansion-panel style="background-color: #f9f9f9;" [expanded]="false" hideToggle="true" #contacts>
        <mat-expansion-panel-header>
          <mat-panel-title>
            @if (!contacts?.expanded) {
              <mat-icon style="color:green; font-size:140%">add_circle</mat-icon>
            }
            @if (contacts?.expanded) {
              <mat-icon style="color:grey; font-size:140%">unfold_less</mat-icon>
            }
            &nbsp;User
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-card>
          <mat-card-content class="row wrap">
            <mat-form-field class="col-lg-5">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.firstName; track validation) {
                <mat-error>
                  @if (userAddForm.get('firstName').hasError(validation.type) && (userAddForm.get('firstName').dirty || userAddForm.get('firstName').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-5">
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="lastName" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.lastName; track validation) {
                <mat-error>
                  @if (userAddForm.get('lastName').hasError(validation.type) && (userAddForm.get('lastName').dirty || userAddForm.get('lastName').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-2">
              <mat-label>Position</mat-label>
              <input matInput formControlName="title" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.title; track validation) {
                <mat-error>
                  @if (userAddForm.get('title').hasError(validation.type) && (userAddForm.get('title').dirty || userAddForm.get('title').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-4">
              <mat-label>Email</mat-label> <input matInput formControlName="email" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.email; track validation) {
                <mat-error>
                  @if (userAddForm.get('email').hasError(validation.type) && (userAddForm.get('email').dirty || userAddForm.get('email').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-2">
              <mat-label>Phone</mat-label> <input matInput formControlName="phone" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.phone; track validation) {
                <mat-error>
                  @if (userAddForm.get('phone').hasError(validation.type) && (userAddForm.get('phone').dirty || userAddForm.get('phone').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-2">
              <mat-label>Phone Type</mat-label>
              <mat-select [(value)]="userAddForm.value.phoneType" formControlName="phoneType">
                @for ( stat of phoneTypes; track  stat) {
                  <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                }
              </mat-select>
              @for (validation of validationMessages.phoneType; track validation) {
                <mat-error>
                  @if (userAddForm.get('phoneType').hasError(validation.type) && (userAddForm.get('phoneType').dirty || userAddForm.get('phoneType').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-6">
              <mat-label>Company Name</mat-label> <input matInput formControlName="companyName" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.companyName; track validation) {
                <mat-error>
                  @if (userAddForm.get('companyName').hasError(validation.type) && (userAddForm.get('companyName').dirty || userAddForm.get('companyName').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-6">
              <mat-label>Website</mat-label> <input matInput formControlName="website" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.website; track validation) {
                <mat-error>
                  @if (userEditForm.get('website').hasError(validation.type) && (userEditForm.get('website').dirty || userEditForm.get('website').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>
            <div class="flex-1" style="float: right">
              <button mat-raised-button color="primary" (click)="formAdd();contacts.expanded = false;" style="float: right;">Add</button>
              <button mat-button type="button" style="float: right;" (click)="contacts.expanded = false;">Cancel</button>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-expansion-panel>
    </mat-accordion>
  </form>
</div>

<p-table #pt [value]="users" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" [pageLinks]="10" [lazy]="true" (onLazyLoad)="loadLazy($event)" [totalRecords]="recordTotal" [responsive]="true"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" dataKey="userId" [style]="{'width':'100%'}" styleClass="p-datatable-striped">

  <ng-template pTemplate="header">
    <tr>
      <th [pSortableColumn]="'userId'">UserId <p-sortIcon [field]="'userId'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'status'">Status <p-sortIcon [field]="'status'"></p-sortIcon>
  </th>
  <th [pSortableColumn]="'firstName'">First <p-sortIcon [field]="'firstName'"></p-sortIcon>
</th>
<th [pSortableColumn]="'lastName'">Last <p-sortIcon [field]="'lastName'"></p-sortIcon>
</th>
<th [pSortableColumn]="'emailAddress'">Email <p-sortIcon [field]="'emailAddress'"></p-sortIcon>
</th>
<th [pSortableColumn]="'lastLogin'">Last Login <p-sortIcon [field]="'lastLogin'"></p-sortIcon>
</th>
</tr>

<tr>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'userId', 'in')"></th>
  <th>
    <p-multiSelect [options]="userStatusOptions" defaultLabel="Status" (onChange)="pt.filter($event.value, 'status', 'in')"></p-multiSelect>
  </th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'firstName', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lastName', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'emailAddress', 'in')"></th>
</tr>
</ng-template>
<ng-template pTemplate="body" let-user let-expanded="expanded">
  <tr [pRowToggler]="user" (click)="patchUser(user)">
    <td>{{user.userId}}</td>
    <td>{{user.status}}</td>
    <td>{{user.firstName}}</td>
    <td>{{user.lastName}}</td>
    <td>{{user.email}}</td>
    <td>{{user.lastLogin |  date:'short'}}</td>
  </tr>
</ng-template>
<ng-template pTemplate="rowexpansion" let-user let-columns="columns">
  <tr>
    <td style="width:100%;border:2px solid blue;" colspan="6">
      <!-- <app-ei-multi-select form="userEditForm"></app-ei-multi-select>  -->

      <form [formGroup]="userEditForm">
        <mat-tab-group>
          <mat-tab label="Details">
            <div class="container-fluid">
              <mat-card>
                <mat-card-content class="row wrap">

                  <mat-form-field class="col-lg-5">
                    <mat-label>First Name</mat-label> <input matInput formControlName="firstName" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.firstName; track validation) {
                      <mat-error>
                        @if (userEditForm.get('firstName').hasError(validation.type) && (userEditForm.get('firstName').dirty || userEditForm.get('firstName').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>


                  <mat-form-field class="col-lg-5">
                    <mat-label>Last Name</mat-label> <input matInput formControlName="lastName" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.lastName; track validation) {
                      <mat-error>
                        @if (userEditForm.get('lastName').hasError(validation.type) && (userEditForm.get('lastName').dirty || userEditForm.get('lastName').touched)) {
                          <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field class="col-lg-2">
                    <mat-label>Position</mat-label>
                    <input matInput formControlName="title" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.title; track validation) {
                      <mat-error>
                        @if (userEditForm.get('title').hasError(validation.type) && (userEditForm.get('title').dirty || userEditForm.get('title').touched)) {
                          <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field class="col-lg-5">
                    <mat-label>Email</mat-label> <input matInput formControlName="email" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.email; track validation) {
                      <mat-error>
                        @if (userEditForm.get('email').hasError(validation.type) && (userEditForm.get('email').dirty || userEditForm.get('email').touched)) {
                          <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field class="col-lg-5">
                    <mat-label>Phone</mat-label> <input matInput formControlName="phone" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.phone; track validation) {
                      <mat-error>
                        @if (userEditForm.get('phone').hasError(validation.type) && (userEditForm.get('phone').dirty || userEditForm.get('phone').touched)) {
                          <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field class="col-lg-2">
                    <mat-label>Phone Type</mat-label>
                    <mat-select [(value)]="userEditForm.value.phoneType" formControlName="phoneType">
                      @for ( stat of phoneTypes; track  stat) {
                        <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.phoneType; track validation) {
                      <mat-error>
                        @if (userEditForm.get('phoneType').hasError(validation.type) && (userEditForm.get('phoneType').dirty || userEditForm.get('phoneType').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field class="col-lg-6">
                    <mat-label>Company Name</mat-label> <input matInput formControlName="companyName" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.companyName; track validation) {
                      <mat-error>
                        @if (userEditForm.get('companyName').hasError(validation.type) && (userEditForm.get('companyName').dirty || userEditForm.get('companyName').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field class="col-lg-6">
                    <mat-label>Website</mat-label> <input matInput formControlName="website" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.website; track validation) {
                      <mat-error>
                        @if (userEditForm.get('website').hasError(validation.type) && (userEditForm.get('website').dirty || userEditForm.get('website').touched)) {
                          <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>

                  <div class="col-lg-6">
                    <div class="row wrap">
                      <h2 class="col-lg-12">Additional Emails</h2>
                      <mat-form-field class="col-lg-3">
                        <mat-label>Email Type</mat-label>
                        <mat-select [(value)]="userEditForm.value.emailType" formControlName="emailType">
                          @for ( stat of emailTypes; track  stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.emailType; track validation) {
                          <mat-error>
                            @if (userEditForm.get('emailType').hasError(validation.type) && (userEditForm.get('emailType').dirty || userEditForm.get('emailType').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-9">
                        <mat-label>Email</mat-label> <input matInput formControlName="email" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.email; track validation) {
                          <mat-error>
                            @if (userAddForm.get('email').hasError(validation.type) && (userAddForm.get('email').dirty || userAddForm.get('email').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-3">
                        <mat-label>Email Type</mat-label>
                        <mat-select [(value)]="userEditForm.value.email2Type" formControlName="email2Type">
                          @for ( stat of emailTypes; track  stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.email2Type; track validation) {
                          <mat-error>
                            @if (userEditForm.get('email2Type').hasError(validation.type) && (userEditForm.get('email2Type').dirty || userEditForm.get('email2Type').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-9">
                        <mat-label>Email</mat-label> <input matInput formControlName="email2" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.email2; track validation) {
                          <mat-error>
                            @if (userAddForm.get('email2').hasError(validation.type) && (userAddForm.get('email2').dirty || userAddForm.get('email2').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-3">
                        <mat-label>Email Type</mat-label>
                        <mat-select [(value)]="userEditForm.value.email3Type" formControlName="email3Type">
                          @for ( stat of emailTypes; track  stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.email3Type; track validation) {
                          <mat-error>
                            @if (userEditForm.get('email3Type').hasError(validation.type) && (userEditForm.get('email3Type').dirty || userEditForm.get('email3Type').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-9">
                        <mat-label>Email</mat-label> <input matInput formControlName="email3" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.email3; track validation) {
                          <mat-error>
                            @if (userAddForm.get('email3').hasError(validation.type) && (userAddForm.get('email3').dirty || userAddForm.get('email3').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-3">
                        <mat-label>Email Type</mat-label>
                        <mat-select [(value)]="userEditForm.value.email4Type" formControlName="email4Type">
                          @for ( stat of emailTypes; track  stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.email4Type; track validation) {
                          <mat-error>
                            @if (userEditForm.get('email4Type').hasError(validation.type) && (userEditForm.get('email4Type').dirty || userEditForm.get('email4Type').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-9">
                        <mat-label>Email</mat-label> <input matInput formControlName="email4" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.email4; track validation) {
                          <mat-error>
                            @if (userAddForm.get('email4').hasError(validation.type) && (userAddForm.get('email4').dirty || userAddForm.get('email4').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>

                  <div style="flex: 0 0 calc(50% - 10px)">
                    <div class="row wrap">
                      <h2 class="col-lg-12">Additional Phone</h2>
                      <mat-form-field class="col-lg-3">
                        <mat-label>Phone Type</mat-label>
                        <mat-select [(value)]="userEditForm.value.phoneType" formControlName="phoneType">
                          @for ( stat of phoneTypes; track  stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.phoneType; track validation) {
                          <mat-error>
                            @if (userEditForm.get('phoneType').hasError(validation.type) && (userEditForm.get('phoneType').dirty || userEditForm.get('phoneType').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-9">
                        <mat-label>Phone</mat-label> <input matInput formControlName="phone" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.phone; track validation) {
                          <mat-error>
                            @if (userEditForm.get('phone').hasError(validation.type) && (userEditForm.get('phone').dirty || userEditForm.get('phone').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-3">
                        <mat-label>Phone Type</mat-label>
                        <mat-select [(value)]="userEditForm.value.phone2Type" formControlName="phone2Type">
                          @for ( stat of phoneTypes; track  stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.phone2Type; track validation) {
                          <mat-error>
                            @if (userEditForm.get('phone2Type').hasError(validation.type) && (userEditForm.get('phone2Type').dirty || userEditForm.get('phone2Type').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-9">
                        <mat-label>Phone</mat-label> <input matInput formControlName="phone2" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.phone2; track validation) {
                          <mat-error>
                            @if (userEditForm.get('phone2').hasError(validation.type) && (userEditForm.get('phone2').dirty || userEditForm.get('phone2').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-3">
                        <mat-label>Phone Type</mat-label>
                        <mat-select [(value)]="userEditForm.value.phone3Type" formControlName="phone3Type">
                          @for ( stat of phoneTypes; track  stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.phone3Type; track validation) {
                          <mat-error>
                            @if (userEditForm.get('phone3Type').hasError(validation.type) && (userEditForm.get('phone3Type').dirty || userEditForm.get('phone3Type').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-9">
                        <mat-label>Phone</mat-label> <input matInput formControlName="phone3" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.phone3; track validation) {
                          <mat-error>
                            @if (userEditForm.get('phone3').hasError(validation.type) && (userEditForm.get('phone3').dirty || userEditForm.get('phone3').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-3">
                        <mat-label>Phone Type</mat-label>
                        <mat-select [(value)]="userEditForm.value.phone4Type" formControlName="phone4Type">
                          @for ( stat of phoneTypes; track  stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.phone4Type; track validation) {
                          <mat-error>
                            @if (userEditForm.get('phone4Type').hasError(validation.type) && (userEditForm.get('phone4Type').dirty || userEditForm.get('phone4Type').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-9">
                        <mat-label>Phone</mat-label> <input matInput formControlName="phone4" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.phone4; track validation) {
                          <mat-error>
                            @if (userEditForm.get('phone4').hasError(validation.type) && (userEditForm.get('phone4').dirty || userEditForm.get('phone4').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-3">
                        <mat-label>Phone Type</mat-label>
                        <mat-select [(value)]="userEditForm.value.phone5Type" formControlName="phone5Type">
                          @for ( stat of phoneTypes; track  stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.phone5Type; track validation) {
                          <mat-error>
                            @if (userEditForm.get('phone5Type').hasError(validation.type) && (userEditForm.get('phone5Type').dirty || userEditForm.get('phone5Type').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-9">
                        <mat-label>Phone</mat-label> <input matInput formControlName="phone5" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.phone5; track validation) {
                          <mat-error>
                            @if (userEditForm.get('phone5').hasError(validation.type) && (userEditForm.get('phone5').dirty || userEditForm.get('phone5').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <h2>Address</h2>
                  </div>



                  <div class="col-lg-6">
                    <div class="row wrap">
                      <h3 class="col-lg-12">Primary</h3>

                      <mat-form-field class="col-lg-6">
                        <mat-label>Address Type</mat-label>
                        <mat-select [(value)]="userEditForm.value.adrType" formControlName="adrType">
                          @for (stat of addressTypes; track stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.adrType; track validation) {
                          <mat-error>
                            @if (userEditForm.get('adrType').hasError(validation.type) && (userEditForm.get('adrType').dirty || userEditForm.get('adrType').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-6">
                        <mat-label>Country</mat-label>
                        <mat-select [(value)]="userEditForm.value.adrCountry" formControlName="adrCountry">
                          @for (stat of countries; track stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.adrCountry; track validation) {
                          <mat-error>
                            @if (userEditForm.get('adrCountry').hasError(validation.type) && (userEditForm.get('adrCountry').dirty || userEditForm.get('adrCountry').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-12">
                        <mat-label>Address</mat-label> <input matInput formControlName="adrStreet" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.adrStreet; track validation) {
                          <mat-error>
                            @if (userEditForm.get('adrStreet').hasError(validation.type) && (userEditForm.get('adrStreet').dirty || userEditForm.get('adrStreet').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-12">
                        <mat-label>Address 2</mat-label> <input matInput formControlName="adrStreet2" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.adrStreet2; track validation) {
                          <mat-error>
                            @if (userEditForm.get('adrStreet2').hasError(validation.type) && (userEditForm.get('adrStreet2').dirty || userEditForm.get('adrStreet2').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-5">
                        <mat-label>City</mat-label> <input matInput formControlName="adrCity" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.adrCity; track validation) {
                          <mat-error>
                            @if (userEditForm.get('adrCity').hasError(validation.type) && (userEditForm.get('adrCity').dirty || userEditForm.get('adrCity').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-5">
                        <mat-label>State</mat-label> <input matInput formControlName="adrState" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.adrState; track validation) {
                          <mat-error>
                            @if (userEditForm.get('adrState').hasError(validation.type) && (userEditForm.get('adrState').dirty || userEditForm.get('adrState').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-2">
                        <mat-label>Postal Code</mat-label> <input matInput formControlName="adrPostalCode" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.adrPostalCode; track validation) {
                          <mat-error>
                            @if (userEditForm.get('adrPostalCode').hasError(validation.type) && (userEditForm.get('adrPostalCode').dirty || userEditForm.get('adrPostalCode').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="row wrap">
                      <h3 class="col-lg-12">Alternate</h3>

                      <mat-form-field class="col-lg-6">
                        <mat-label>Address Type</mat-label>
                        <mat-select [(value)]="userEditForm.value.adr2Type" formControlName="adr2Type">
                          @for (stat of addressTypes; track stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.adr2Type; track validation) {
                          <mat-error>
                            @if (userEditForm.get('adr2Type').hasError(validation.type) && (userEditForm.get('adr2Type').dirty || userEditForm.get('adr2Type').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-6">
                        <mat-label>Country</mat-label>
                        <mat-select [(value)]="userEditForm.value.adr2Country" formControlName="adr2Country">
                          @for (stat of countries; track stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.adr2Country; track validation) {
                          <mat-error>
                            @if (userEditForm.get('adr2Country').hasError(validation.type) && (userEditForm.get('adr2Country').dirty || userEditForm.get('adr2Country').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-12">
                        <mat-label>Address</mat-label> <input matInput formControlName="adr2Street" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.adr2Street; track validation) {
                          <mat-error>
                            @if (userEditForm.get('adr2Street').hasError(validation.type) && (userEditForm.get('adr2Street').dirty || userEditForm.get('adr2Street').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-12">
                        <mat-label>Address 2</mat-label> <input matInput formControlName="adr2Street2" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.adr2Street2; track validation) {
                          <mat-error>
                            @if (userEditForm.get('adr2Street2').hasError(validation.type) && (userEditForm.get('adr2Street2').dirty || userEditForm.get('adr2Street2').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-5">
                        <mat-label>City</mat-label> <input matInput formControlName="adr2City" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.adr2City; track validation) {
                          <mat-error>
                            @if (userEditForm.get('adr2City').hasError(validation.type) && (userEditForm.get('adr2City').dirty || userEditForm.get('adr2City').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-5">
                        <mat-label>State</mat-label> <input matInput formControlName="adr2State" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.adr2State; track validation) {
                          <mat-error>
                            @if (userEditForm.get('adr2State').hasError(validation.type) && (userEditForm.get('adr2State').dirty || userEditForm.get('adr2State').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-12">
                        <mat-label>Postal Code</mat-label> <input matInput formControlName="adr2PostalCode" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.adr2PostalCode; track validation) {
                          <mat-error>
                            @if (userEditForm.get('adr2PostalCode').hasError(validation.type) && (userEditForm.get('adr2PostalCode').dirty || userEditForm.get('adr2PostalCode').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>


                  <div class="col-lg-12">
                    <h2>Profile</h2>
                  </div>


                  <div class="col-lg-6">
                    <div class="row wrap">
                      <h3 class="col-lg-12">Personal</h3>

                      <mat-form-field class="col-lg-6">
                        <mat-label>Gender</mat-label>
                        <mat-select [(value)]="userAddForm.value.gender" formControlName="gender">
                          @for ( stat of genders; track  stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.gender; track validation) {
                          <mat-error>
                            @if (userAddForm.get('gender').hasError(validation.type) && (userAddForm.get('gender').dirty || userAddForm.get('gender').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-6">
                        <mat-label>LLC/Corp Tax Id</mat-label> <input matInput formControlName="language" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.language; track validation) {
                          <mat-error>
                            @if (userEditForm.get('language').hasError(validation.type) && (userEditForm.get('language').dirty || userEditForm.get('language').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-6">
                        <mat-label>Date of Birth</mat-label> <input matInput [matDatepicker]="birthdatePicker" formControlName="birthdate">
                        <mat-datepicker-toggle matSuffix [for]="birthdatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #birthdatePicker disabled="false"></mat-datepicker>
                        @for (validation of validationMessages.birthdate; track validation) {
                          <mat-error>
                            @if (userEditForm.get('birthdate').hasError(validation.type) && (userEditForm.get('birthdate').dirty || userEditForm.get('birthdate').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-6">
                        <mat-label>Birthday</mat-label> <input matInput [matDatepicker]="birthdayPicker" formControlName="birthday">
                        <mat-datepicker-toggle matSuffix [for]="birthdayPicker"></mat-datepicker-toggle>
                        <mat-datepicker #birthdayPicker disabled="false"></mat-datepicker>
                        @for (validation of validationMessages.birthday; track validation) {
                          <mat-error>
                            @if (userEditForm.get('birthday').hasError(validation.type) && (userEditForm.get('birthday').dirty || userEditForm.get('birthday').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-6">
                        <mat-label>Company License</mat-label> <input matInput formControlName="companyLicense" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.companyLicense; track validation) {
                          <mat-error>
                            @if (userEditForm.get('companyLicense').hasError(validation.type) && (userEditForm.get('companyLicense').dirty || userEditForm.get('companyLicense').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <h3 class="col-lg-12">Tax</h3>

                      <mat-form-field class="col-lg-6">
                        <mat-label>LLC/Corp Tax Id</mat-label> <input matInput formControlName="taxID" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.taxID; track validation) {
                          <mat-error>
                            @if (userEditForm.get('taxID').hasError(validation.type) && (userEditForm.get('taxID').dirty || userEditForm.get('taxID').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-6">
                        <mat-label>SSN</mat-label> <input matInput formControlName="sSN" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.sSN; track validation) {
                          <mat-error>
                            @if (userEditForm.get('sSN').hasError(validation.type) && (userEditForm.get('sSN').dirty || userEditForm.get('sSN').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <h3 class="col-lg-12">Notes</h3>

                      <mat-form-field class="col-lg-12">
                        <mat-label>Description</mat-label>
                        <textarea matInput formControlName="notes" readonly="{{formReadOnly}}" matTextareaAutosize matAutosizeMinRows=10 matAutosizeMaxRows=500></textarea>
                        @for (validation of validationMessages.notes; track validation) {
                          <mat-error>
                            @if (userEditForm.get('notes').hasError(validation.type) && (userEditForm.get('notes').dirty || userEditForm.get('notes').touched)) {
                              <mat-error class="error-notes">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="row wrap">
                      <h3 class="col-lg-12">Family</h3>

                      <mat-form-field class="col-lg-12">
                        <mat-label>Anniversary</mat-label> <input matInput [matDatepicker]="anniversaryPicker" formControlName="anniversary">
                        <mat-datepicker-toggle matSuffix [for]="anniversaryPicker"></mat-datepicker-toggle>
                        <mat-datepicker #anniversaryPicker disabled="false"></mat-datepicker>
                        @for (validation of validationMessages.anniversary; track validation) {
                          <mat-error>
                            @if (userEditForm.get('anniversary').hasError(validation.type) && (userEditForm.get('anniversary').dirty || userEditForm.get('anniversary').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-lg-6">
                        <mat-label>Children</mat-label>
                        <input matInput formControlName="children" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.children; track validation) {
                          <mat-error>
                            @if (userEditForm.get('children').hasError(validation.type) && (userEditForm.get('children').dirty || userEditForm.get('children').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex-1" style="float: right">
                    <hr>
                      <button mat-raised-button color="primary" (click)="formUpdate();" style="float: right;">Update</button>&nbsp;
                      <button mat-button type="button" style="float: right;" (click)="pt.toggleRow(user)">Cancel</button>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </mat-tab>

            <mat-tab label="Credentials">
              <mat-card>
                <mat-card-content class="row">

                  <mat-form-field class="col-lg-12">
                    <mat-select placeholder="Status" [(value)]="userEditForm.value.status" formControlName="status">
                      @for ( stat of userStatusOptions; track  stat) {
                        <mat-option [value]="stat.value">
                          {{stat.label}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field class="col-lg-12">
                    <mat-label>Username</mat-label>
                    <input matInput formControlName="username" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.username; track validation) {
                      <mat-error>
                        @if (userEditForm.get('username').hasError(validation.type) && (userEditForm.get('username').dirty || userEditForm.get('username').touched)) {
                          <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>


                  <mat-form-field class="col-lg-12">
                    <mat-label>Failed Login Attempts</mat-label>
                    <input matInput formControlName="failedloginCount" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.failedloginCount; track validation) {
                      <mat-error>
                        @if (userEditForm.get('failedloginCount').hasError(validation.type) && (userEditForm.get('failedloginCount').dirty || userEditForm.get('failedloginCount').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>


                  <mat-form-field class="col-lg-12">
                    <mat-label>Password Reset Hint Question</mat-label>
                    <input matInput formControlName="hintQuestion" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.hintQuestion; track validation) {
                      <mat-error>
                        @if (userEditForm.get('hintQuestion').hasError(validation.type) && (userEditForm.get('hintQuestion').dirty || userEditForm.get('hintQuestion').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>


                  <mat-form-field class="col-lg-12">
                    <mat-label>Password Reset Hint Answer</mat-label>
                    <input matInput formControlName="hintAnswer" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.hintAnswer; track validation) {
                      <mat-error>
                        @if (userEditForm.get('hintAnswer').hasError(validation.type) && (userEditForm.get('hintAnswer').dirty || userEditForm.get('hintAnswer').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>


                  <h3>Roles</h3>
                  <mat-checkbox formControlName="selectAll">Select/Unselect all</mat-checkbox>
                  <!-- Changed when compiling production version -->
                  <!-- <ng-container formArrayName="userRoles" *ngFor="let genre of form1.controls['userRoles'].controls; let i = index"></ng-container> -->
                  @for (genre of userEditForm['controls'].userRoles['controls']; track genre; let i = $index) {
                    <ng-container formArrayName="userRoles">
                      &nbsp;&nbsp;&nbsp;&nbsp;<mat-checkbox type="checkbox" [formControlName]="i">
                    {{userRoleList[i].name}} (#{{userRoleList[i].userRoleId }})</mat-checkbox>
                  </ng-container>
                }

                <div class="flex-1" style="float: right">
                  <hr>
                    <button mat-raised-button color="secondary" (click)="onPasswordReset(user)" style="float: left;">Reset Password</button>&nbsp;
                    <button mat-raised-button color="primary" (click)="formUpdate();" style="float: right;">Update</button>&nbsp;
                    <button mat-button type="button" style="float: right;" (click)="pt.toggleRow(user)">Cancel</button>
                  </div>
                </mat-card-content>
              </mat-card>
            </mat-tab>
          </mat-tab-group>
        </form>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="paginatorleft">&nbsp;Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} -
    {{recordTotal > 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows + lazyLoadEvent.first) : recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}}
  </ng-template>
</p-table>
